import { MANUSCRIPT_URL } from ".";

export const MANUSCRIPT_MY_ROUTE_FACTOR = "my";
export const MANUSCRIPT_ALL_ROUTE_FACTOR = "all";
export const MANUSCRIPT_BOOK_ROUTE_FACTOR = "book";
export const MANUSCRIPT_NOVEL_ROUTE_FACTOR = "novel";
export const MANUSCRIPT_VIEW_ROUTE_FACTOR = "view";
export const MANUSCRIPT_LIST_ROUTE_FACTOR = "list";
export const MANUSCRIPT_LIST_URL = `/${MANUSCRIPT_URL}/${MANUSCRIPT_LIST_ROUTE_FACTOR}`;
export const MANUSCRIPT_BOOK_URL = `${MANUSCRIPT_LIST_URL}/${MANUSCRIPT_BOOK_ROUTE_FACTOR}`;
export const MANUSCRIPT_NOVEL_URL = `${MANUSCRIPT_LIST_URL}/${MANUSCRIPT_NOVEL_ROUTE_FACTOR}`;
export const MANUSCRIPT_VIEW_URL = `/${MANUSCRIPT_URL}/${MANUSCRIPT_VIEW_ROUTE_FACTOR}`;
export const MANUSCRIPT_MY_URL = `${MANUSCRIPT_LIST_URL}/${MANUSCRIPT_MY_ROUTE_FACTOR}`;
export const MANUSCRIPT_ALL_URL = `${MANUSCRIPT_LIST_URL}/${MANUSCRIPT_ALL_ROUTE_FACTOR}`;
